import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Textarea } from 'primeng/textarea';
import { Bill } from '../bill-data.service';

@Component({
  selector: 'app-cancel-bill-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonModule, Textarea],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="flex flex-column gap-3">
        <div class="flex flex-column gap-2">
          <label for="reason" class="font-medium">Cancellation Reason *</label>
          <textarea
            id="reason"
            pInputTextarea
            formControlName="reason"
            rows="4"
            class="w-full"
            placeholder="Enter the reason for cancelling this bill...">
          </textarea>
          @if (form.get('reason')?.invalid && form.get('reason')?.touched) {
            <small class="p-error">Cancellation reason is required</small>
          }
        </div>

        <div class="flex justify-content-end gap-2 mt-3">
          <p-button type="button" label="Cancel" severity="secondary" [text]="true" (onClick)="onCancel()"> </p-button>
          <p-button type="submit" label="Confirm Cancellation" severity="danger" [disabled]="form.invalid"> </p-button>
        </div>
      </div>
    </form>
  `,
})
export class CancelBillDialogComponent {
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);

  bill: Bill = this.config.data.bill;

  form = new FormGroup({
    reason: new FormControl('', [Validators.required, Validators.minLength(5)]),
  });

  onSubmit() {
    if (this.form.valid) {
      this.ref.close({ reason: this.form.value.reason });
    }
  }

  onCancel() {
    this.ref.close();
  }
}
